import React from 'react';
import CountUp from './CountUp';

// A number that counts up (react-bits CountUp), Indian grouping. Non-numbers (— , text) show as they are.
export default function Num({ value, prefix = '' }) {
  const n = typeof value === 'number' ? value : Number(value);
  if (value === null || value === undefined || value === '' || !Number.isFinite(n)) return <>{prefix}{value ?? '—'}</>;
  return <CountUp to={Math.round(n)} prefix={prefix} separator="," duration={1} trigger="load" />;
}
